export const SYNC_EVENT_ADDED = 'SYNC_EVENT_ADDED';
export const SYNC_EVENT_UPDATED = 'SYNC_EVENT_UPDATED';
export const SYNC_EVENT_DELETED = 'SYNC_EVENT_DELETED';
// Action creators for sync events
export const syncEventAdded = (eventData) => ({
    type: SYNC_EVENT_ADDED,
    payload: eventData
});

export const syncEventUpdated = (eventData) => ({
    type: SYNC_EVENT_UPDATED,
    payload: eventData
});

export const syncEventDeleted = (eventData) => ({
    type: SYNC_EVENT_DELETED,
    payload: eventData
});